import { render } from "./ContactosView.vue?vue&type=template&id=17149a8f"
import script from "./ContactosView.vue?vue&type=script&lang=js"
export * from "./ContactosView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__